module.exports = __webpack_public_path__ + "static/media/YM15_3.918cff4f.jpg";